import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const rmsLoteRoutes: Routes = [
  {
    path: 'consultar-rms/gerenciar-rms-lote',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./rms-lote.component').then((m) => m.RmsLoteComponent),
        data: {
          title: 'Gerenciar RMS - Lote',
          roles: [Role.RMS_LOTE_CONSULTAR, Role.RMS_LOTE_GERAR],
          breadcrumb: [
            { label: 'Consultar RMS', url: '/consultar-rms' },
            {
              label: 'Gerenciar RMS - Lote',
              url: '/consultar-rms/gerenciar-rms-lote',
            },
          ],
        },
      },
      {
        path: 'portarias',
        loadComponent: () =>
          import('./rms-lote-portarias.component').then((m) => m.RmsLotePortariasComponent),
        data: {
          title: 'Gerenciar Lotes e Portarias - RMS',
          roles: [Role.RMS_LOTE_CONSULTAR, Role.RMS_LOTE_GERAR],
          breadcrumb: [
            { label: 'Consultar RMS', url: '/consultar-rms' },
            {
              label: 'Gerenciar RMS - Lote',
              url: '/consultar-rms/gerenciar-rms-lote',
            },
            {
              label: 'Lotes e Portarias - RMS',
              url: '/consultar-rms/gerenciar-rms-lote/portarias',
            },
          ],
        },
      },
    ],
  },
];
